import { Action, ErrorCodes, OperationType } from "puzzle";

export const pingingRequest: Action = [{
  actionType: {
    dispatcherId: 'mainDispatcher'
  },
  persistent: ['url', 'method'],
  type: OperationType.addPersistentData
}, {
  condition: '!_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    condition: '{responseData} && {responseData.processingFinished}',
    conditionOperations: [{
      items: ['responseData'],
      type: OperationType.syncDispatchersDataItem
    }, {
      condition: '{additionalDataSync}',
      conditionOperations: [{
        evaluate: true,
        name: '{additionalDataSync}',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      condition: '!{afterPingFinishAction}',
      conditionOperations: [{
        items: ['afterPingFinishAction'],
        type: OperationType.syncDispatchersDataItem,
        referenceDispatcherId: 'mainDispatcher'
      }],
      type: OperationType.conditional
    }, {
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      evaluate: true,
      name: '{afterPingFinishAction}',
      type: OperationType.action
    }, {
      name: 'stopPingingRequest',
      type: OperationType.action
    }],
    elseOperations: [{
      actionType: {
        dispatcherId: "batchPingDispatcher",
        delay: 1000
      },
      data: {
        template: {
          processId: {
            bind: {
              processId: '{responseData.processId}'
            }
          }
        }
      },
      name: 'continueWithPingingRequest',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    name: 'stopPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const continueWithPingingRequest: Action = [{
  items: ['url', 'method'],
  referenceDispatcherId: 'mainDispatcher',
  type: OperationType.syncDispatchersDataItem
}, {
  condition: '{url}',
  conditionOperations: [{
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    type: OperationType.request,
    data: {
      template: {
        headers: {
          bind: {
            'X-Process-Uuid': '{processId.processId}'
          }
        },
        bind: {
          method: '{method}',
          url: '{url}'
        }
      }
    },
    mappingName: 'responseData'
  }, {
    items: ['responseData'],
    type: OperationType.syncDispatchersDataItem
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'processRequestError',
    type: OperationType.action
  }, {
    name: 'pingingRequest',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'stopPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

/** Might be needed as configurable action, to cover all pinging requests on supplier
 * possible pinging request errors [ REST.ERR.ACTION.INCOMPLETE ]
 */
export const processRequestError: Action = [{
  condition: `!!_.get({responseData}, 'response.data.errors')`,
  conditionOperations: [{
    condition: `_.get({responseData},'response.data.errors[0].errorCode')`,
    "REST.ERR.ACTION.INCOMPLETE": [{
      name: 'incompleteFileUploadWarning',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }, {
      dispatcherIds: ['mainDispatcher'],
      type: OperationType.stopAll
    }],
    defaultOperations: [{
      name: 'handleRequestException',
      type: OperationType.action
    }],
    type: OperationType.switch
  }],
  type: OperationType.conditional
}];

/**
 * Stop pinging and clear all leftovers
 */
export const stopPingingRequest: Action = [{
  dispatcherIds: ['batchPingDispatcher'],
  type: OperationType.unlink
}, {
  persistent: ['url', 'method', 'afterPingFinishAction', 'filterModuleName'],
  type: OperationType.removePersistentData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}]